import HistSearchLocation from "./HistSearchLocation";

export default HistSearchLocation;